export default __webpack_public_path__ + "static/hmt-f1c035e6f5ce0d6550ca3c29dc0a9333.png";